const state = {
  assigned_points: undefined,
  description: undefined,
  data: {},
  id: null,
  qc_category_key: '',
  task_list_template_id: undefined,
  task_list_template_section_id: undefined,
  title: '',
}

export const requiredFields = [
  { key: 'assigned_points' },
  { key: 'title' },
  { key: 'task_list_template_id' },
  { key: 'task_list_template_section_id' },
]

export default state
